import clsx from 'clsx';
import { TableHeaderConfig } from 'types/table/TableHeaderConfig.type';
import styles from '../components/organisms/case-tracking-table/case-tracking.module.scss';

interface CaseTrackingColumns {
  created: Date;
  instructionNumber: number;
  clientName: string;
  instructionType: string;
  proposalNumber: number;
  investmentNumber: string;
  stage: unknown;
  lastModified: Date;
}

export const caseTrackingTableHeaderData: TableHeaderConfig<CaseTrackingColumns>[] = [
  {
    key: 'created',
    label: 'Created',
    className: clsx(styles.headers)
  },
  {
    key: 'instructionNumber',
    label: 'Instruction #',
    className: clsx(styles.headers)
  },
  {
    key: 'clientName',
    label: 'Client name',
    className: clsx(styles.headers)
  },
  {
    key: 'instructionType',
    label: 'Instruction type',
    className: clsx(styles.headers)
  },
  {
    key: 'proposalNumber',
    label: 'Proposal #',
    className: clsx(styles.headers)
  },
  {
    key: 'investmentNumber',
    label: 'Investment #',
    className: clsx(styles.headers)
  },
  {
    key: 'stage',
    label: 'Stage & status',
    className: clsx(styles.stageStatus)
  },
  {
    key: 'lastModified',
    label: 'Last modified',
    className: clsx(styles.headers)
  }
];
